import { isDefined } from '@aloft/toolkit-shared';

export const isWeb = () => isDefined(window);
